import React, { useState } from "react";
import { findAssetByAssetId } from "../app/UrlCrud";

// The manual Asset ID fallback, shared by the scan failure page and the
// camera scanner. Resolution goes through the same authenticated,
// organisation-scoped GET /v2/asset/lookup/by-asset-id endpoint.
export default function AssetIdLookupForm({ onResolved, label = "QR code not working? Enter the Asset ID", idPrefix = "scan", lookup = findAssetByAssetId }) {
    const [assetID, setAssetID] = useState("");
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

    const submit = e => {
        e.preventDefault();
        const value = assetID.trim();
        if (!value) return;
        setBusy(true);
        setError(null);
        lookup(value)
            .then(({ data }) => onResolved(data))
            .catch(() => {
                setError("No asset with that Asset ID was found that you can access.");
                setBusy(false);
            });
    };

    return (
        <form onSubmit={submit}>
            <label className="font-weight-bold" htmlFor={`${idPrefix}-asset-id`}>
                {label}
            </label>
            <div className="d-flex">
                <input
                    id={`${idPrefix}-asset-id`}
                    type="text"
                    className="form-control mr-2"
                    placeholder="Asset ID printed on the label"
                    value={assetID}
                    onChange={e => {
                        const value = e.target.value;
                        setAssetID(value);
                    }}
                />
                <button type="submit" className="btn btn-primary" disabled={busy || !assetID.trim()}>
                    {busy ? "Looking up..." : "Find"}
                </button>
            </div>
            {error && (
                <div className="text-danger mt-2" role="alert">
                    {error}
                </div>
            )}
        </form>
    );
}
